import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { IntegrationErrorRecord, integrationErrorFromJSON } from "common/records/IntegrationError";
import { IntegrationErrorActions, RECEIVE_INTEGRATION_ERRORS } from "common/reducers/integrationError.actions";

export const IntegrationErrorStateRecord = Record({
  byId: Map<string, IntegrationErrorRecord>(),
});

export const initialState = IntegrationErrorStateRecord();

export type IntegrationErrorState = typeof initialState;

export const model = "integrationErrors";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_INTEGRATION_ERRORS:
      action.payload.forEach((error) => {
        const errorRecord = integrationErrorFromJSON(error);
        state = state.setIn([model, "byId", errorRecord.id], errorRecord);
      });
      return state;

    default:
      return state;
  }
};
